import React, { useEffect, useState } from "react"
import {GatsbyImage} from "gatsby-plugin-image"
import MailchimpSubscribe from 'react-mailchimp-subscribe'
import {useForm} from 'react-hook-form'
import styled from "styled-components"
import CMSLink from "components/shared/CMSLink"
import {media} from "utils/Media"
import { navigate } from "gatsby"

const url = "https://img.us12.list-manage.com/subscribe/post?u=0785efbb63e5c3e387c7d7141&id=aca3ce2b62&f_id=009ab5e0f0"

const Wrapper = styled.div`
  display: flex;
  height: 100%;

  @media ${media.lg} {
    .basis-half {
        flex-basis: 50%;
      }
  }

  img {
    width: 300px;
  }

  .content img {
    width: auto;
  }

  h4, p, ul {
    color: white;
    margin-bottom: 1rem;
  }

  a {
    font-family: ${props => props.theme.font.family.bold};
  }

  p {
    font-size: 1rem;
    @media ${media.md} {
      font-size: 1.125rem;
    }
  }

  ul li {
    font-family: ${props => props.theme.font.family.body};
    font-size: 1rem;
    @media ${media.md} {
      font-size: 1.125rem;
    }
  }

  h4 {
    font-family: ${props => props.theme.font.family.heading};
    color: ${props => props.theme.colors.secondary};
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .text-red {
    color: #ff6969;
  }

  .input-wrapper {
    div {
        position: relative;
        border-radius: 0;
        input[type="text"],
        input[type="email"],
        input[type="date"],
        select {
            width: 100%;
            border: none;
            border-radius: 0 !important;
            padding: 0.75rem 0.5rem;
            margin-bottom: 0.5rem;
            outline: none;
            border: solid white 2px;
            height: 45px;
            &::placeholder {
                font-size: 12px;
                font-weight: 400;
                color: #757575;
                @media ${media.ls} {
                    font-size: 15px;
                }
                @media ${media.md} {
                    font-size: 18px;
                }
            }
            @media ${media.md} {
                height: 50px;
            }
        }
        select {
            font-size: 0.65rem;
            outline: none;
            @media ${media.ls} {
                font-size: 15px;
            }
        }
        input[type="date"] {
            font-size: 0.95rem;
            &::placeholder {
                font-size: 0.5rem;
            }
        }
    }
    label {
        font-weight: 500;
        font-size: 14px;
        margin-bottom: 0.35rem;
        display: block;
        color: #fff;
        @media ${media.ls} {
            font-size: 15px;
        }
        @media ${media.md} {
            font-size: 1rem;
        }
    }
    svg {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 0.75rem;
        right: 0.5rem;
        fill: red;
        display: none;
        @media ${media.md} {
            top: 1rem;
            right: 1rem;
        }
    }
}
`

const Bg = styled.div`
  background: rgb(51, 62, 72);
  flex-basis: 100%;
  @media ${media.lg} {
    flex-basis: 50%;
  }
`

const Image = styled.div`
    display: none;
  position: relative;
  @media ${media.md} {
    flex-basis: 50%;
  }
  @media ${media.lg} {
    display: block;
  }
  .gatsby-image-wrapper-constrained {
    display: inline-block;
    vertical-align: top;
  }
  .gatsby-image-wrapper {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  img {
    width: 100%;
  }
`

const NewSweepstake = ({...props}) => {
    return (
        <Wrapper className="flex h-full">
            <Bg className="py-5 px-4 md:p-6">
                {props.title && (
                    <h4 className="max-w-[80%] lg:max-w-none">{props.title}</h4>
                )}
                {props.text && (
                    <div dangerouslySetInnerHTML={{__html: props.text}}
                         className="pb-md-2 [&>ul]:list-disc [&>ul]:pl-8 [&>p>a]:text-white [&>a]:text-white [&>p>a]:underline content"/>
                )}
                {props.displayForm && (
                    <MailchimpSubscribe
                        url={url}
                        render={({subscribe, status, message}) => (
                            <Form
                                status={status}
                                message={message}
                                termsText={props.termsText}
                                successText={props.successText}
                                redirect={props.redirect}
                                redirectPage={props.redirectPage}
                                mailchimpFieldKey={props.mailchimpFieldKey}
                                onValidated={formData => subscribe(formData)}
                            />
                        )}
                    />
                )}
                {props.link && !props.displayForm && (
                    <CMSLink
                        url={props.link.url}
                        target={props.link.target}
                        className="mb-2 mt-3 md:py-2 md:max-w-none w-auto modal-cta"
                        minWidth={false}
                    >
                        {props.link.title}
                    </CMSLink>
                )}
            </Bg>
            {props.image && (
                <Image>
                    <GatsbyImage image={props.image.localFile?.childImageSharp?.gatsbyImageData}
                                 className="absolute object-cover h-full w-full" alt="" />
                </Image>
            )}
        </Wrapper>
    )
};

export default NewSweepstake

const Form = (props) => {
    const [selectedCountry, setSelectedCountry] = useState("");

    console.log(props)

    useEffect(() => {
        if (props.status === "success" && props.redirect && props.redirectPage) {
            navigate(props.redirectPage.uri)
        }
    }, [props.status])

    const {
        register,
        formState: {errors},
        handleSubmit
    } = useForm({
        mode: 'onSubmit',
    })

    const handleChange = event => {
        setSelectedCountry(event.target.value);
    };

    const formatMessage = (message) => {
        if (message.includes("0 - Please enter a value")) {
            return "Please enter your email address."
        }

        if (message.includes("An email address must contain")) {
            return "Please enter a valid email address."
        }

        if (message.includes("The domain portion of the email address is invalid")) {
            return "Please enter a valid email address."
        }

        if (message.includes("This email cannot be added to this list")) {
            return "This email address is already registered. Please enter a different email address."
        }

        return message
    }

    const onSubmit = (data, e) => {
        e.preventDefault()
        if (!data.itsatrap) {
            props.onValidated({
                FNAME: data.firstName,
                LNAME: data.lastName,
                EMAIL: data.email,
                PHONE: data.phone,
                COUNTRY: selectedCountry,
                EMIRATE: data.emirate,
                [props.mailchimpFieldKey]: "Yes"
            });
        }
    }

    return (
        <form className='pt-md-3' onSubmit={handleSubmit(onSubmit)} noValidate>
            {props.status === "success" && props.successText ? (
                <div className='font-bold' dangerouslySetInnerHTML={{__html: props.successText}}/>
            ) : (
                <>
                    <input
                        type="text"
                        id="yourName"
                        name="Name"
                        placeholder="Your name here"
                        className="d-none"
                        autoComplete="none"
                        tabIndex="-1"
                        {...register('itsatrap')}
                    />
                    <div className="pb-2">
                        <input
                            type="text"
                            placeholder="First name"
                            name="firstName"
                            id="firstName"
                            className={`${errors.firstName ? 'error' : ''} w-100 mb-2 p-2`}
                            {...register('firstName', {
                                required: 'Your first name is required',
                            })}
                        />
                        {errors.firstName && (
                            <p className="text-red font-bold"
                               dangerouslySetInnerHTML={{__html: errors.firstName.message}}/>
                        )}
                    </div>
                    <div className="pb-2">
                        <input
                            type="text"
                            placeholder="Last name"
                            name="lastName"
                            id="lastName"
                            className={`${errors.lastName ? 'error' : ''} w-100  mb-2 p-2`}
                            {...register('lastName', {
                                required: 'Your last name is required',
                            })}
                        />
                        {errors.lastName && (
                            <p className="text-red font-bold"
                               dangerouslySetInnerHTML={{__html: errors.lastName.message}}/>
                        )}
                    </div>
                    <div className="pb-2">
                        <input
                            placeholder="Email"
                            type="text"
                            name="email"
                            id="email"
                            className={`${errors.email ? 'error' : ''} w-100 mb-2 p-2`}
                            {...register('email', {
                                required: 'A email address is required',
                                pattern: {
                                    value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                                    message: 'Invalid email address',
                                },
                            })}
                        />
                        {errors.email && (
                            <p className="text-red font-bold"
                               dangerouslySetInnerHTML={{__html: errors.email.message}}/>
                        )}
                    </div>
                    <div className="pb-2">
                        <input
                            type="text"
                            placeholder="Phone number"
                            name="phone"
                            id="phone"
                            className={`${errors.phone ? 'error' : ''} w-100 mb-2 p-2`}
                            {...register('phone', {
                                required: 'Your phone is required',
                            })}
                        />
                        {errors.phone && (
                            <p className="text-red font-bold"
                               dangerouslySetInnerHTML={{__html: errors.phone.message}}/>
                        )}
                    </div>
                    <div
                        className={
                            errors.country ? 'error input-wrapper mb-2' : ' input-wrapper mb-2'
                        }
                    >
                        <label htmlFor="country">Where do you live?</label>
                        <div>
                            <select
                                id="country"
                                name="country"
                                value={selectedCountry}
                                onChange={handleChange}
                            >
                                <option defaultValue="null" value="null">
                                    Where do you live?
                                </option>
                                <option value="United Arab Emirates">United Arab Emirates</option>
                                <option value="Afghanistan">Afghanistan</option>
                                <option value="Albania">Albania</option>
                                <option value="Algeria">Algeria</option>
                                <option value="Andorra">Andorra</option>
                                <option value="Angola">Angola</option>
                                <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                                <option value="Argentina">Argentina</option>
                                <option value="Armenia">Armenia</option>
                                <option value="Aruba">Aruba</option>
                                <option value="Australia">Australia</option>
                                <option value="Austria">Austria</option>
                                <option value="Azerbaijan">Azerbaijan</option>
                                <option value="Bahamas, The">Bahamas, The</option>
                                <option value="Bahrain">Bahrain</option>
                                <option value="Bangladesh">Bangladesh</option>
                                <option value="Barbados">Barbados</option>
                                <option value="Belarus">Belarus</option>
                                <option value="Belgium">Belgium</option>
                                <option value="Belize">Belize</option>
                                <option value="Benin">Benin</option>
                                <option value="Bermuda">Bermuda</option>
                                <option value="Bhutan">Bhutan</option>
                                <option value="Bolivia">Bolivia</option>
                                <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                                <option value="Botswana">Botswana</option>
                                <option value="Brazil">Brazil</option>
                                <option value="Brunei">Brunei</option>
                                <option value="Bulgaria">Bulgaria</option>
                                <option value="Burkina Faso">Burkina Faso</option>
                                <option value="Burundi">Burundi</option>
                                <option value="Cambodia">Cambodia</option>
                                <option value="Cameroon">Cameroon</option>
                                <option value="Canada">Canada</option>
                                <option value="Cape Verde">Cape Verde</option>
                                <option value="Central African Republic">Central African Republic</option>
                                <option value="Chad">Chad</option>
                                <option value="Chile">Chile</option>
                                <option value="China">China</option>
                                <option value="Colombia">Colombia</option>
                                <option value="Comoros">Comoros</option>
                                <option value="Congo, Republic of the">Congo, Republic of the</option>
                                <option value="Congo, Democratic Republic of the">Congo, Democratic Republic of the</option>
                                <option value="Costa Rica">Costa Rica</option>
                                <option value="Cote d'Ivoire">Cote d'Ivoire</option>
                                <option value="Croatia">Croatia</option>
                                <option value="Cuba">Cuba</option>
                                <option value="Cyprus">Cyprus</option>
                                <option value="Czech Republic">Czech Republic</option>
                                <option value="Denmark">Denmark</option>
                                <option value="Djibouti">Djibouti</option>
                                <option value="Dominica">Dominica</option>
                                <option value="Dominican Republic">Dominican Republic</option>
                                <option value="Ecuador">Ecuador</option>
                                <option value="Egypt">Egypt</option>
                                <option value="El Salvador">El Salvador</option>
                                <option value="Equatorial Guinea">Equatorial Guinea</option>
                                <option value="Eritrea">Eritrea</option>
                                <option value="Estonia">Estonia</option>
                                <option value="Ethiopia">Ethiopia</option>
                                <option value="Fiji">Fiji</option>
                                <option value="Finland">Finland</option>
                                <option value="France">France</option>
                                <option value="Gabon">Gabon</option>
                                <option value="Gambia, The">Gambia, The</option>
                                <option value="Georgia">Georgia</option>
                                <option value="Germany">Germany</option>
                                <option value="Ghana">Ghana</option>
                                <option value="Greece">Greece</option>
                                <option value="Grenada">Grenada</option>
                                <option value="Guatemala">Guatemala</option>
                                <option value="Guinea">Guinea</option>
                                <option value="Guinea-Bissau">Guinea-Bissau</option>
                                <option value="Guyana">Guyana</option>
                                <option value="Haiti">Haiti</option>
                                <option value="Honduras">Honduras</option>
                                <option value="Hungary">Hungary</option>
                                <option value="Iceland">Iceland</option>
                                <option value="India">India</option>
                                <option value="Indonesia">Indonesia</option>
                                <option value="Iraq">Iraq</option>
                                <option value="Ireland">Ireland</option>
                                <option value="Islamic Republic of Iran">Islamic Republic of Iran</option>
                                <option value="Israel">Israel</option>
                                <option value="Italy">Italy</option>
                                <option value="Jamaica">Jamaica</option>
                                <option value="Japan">Japan</option>
                                <option value="Jordan">Jordan</option>
                                <option value="Kazakhstan">Kazakhstan</option>
                                <option value="Kenya">Kenya</option>
                                <option value="Kiribati">Kiribati</option>
                                <option value="Korea, The Democratic People's Republic of">Korea, The Democratic People's Republic of</option>
                                <option value="Korea, The Republic of">Korea, The Republic of</option>
                                <option value="Kosovo">Kosovo</option>
                                <option value="Kuwait">Kuwait</option>
                                <option value="Kyrgyzstan">Kyrgyzstan</option>
                                <option value="Lao People's Democratic Republic">Lao People's Democratic Republic</option>
                                <option value="Latvia">Latvia</option>
                                <option value="Lebanon">Lebanon</option>
                                <option value="Lesotho">Lesotho</option>
                                <option value="Liberia">Liberia</option>
                                <option value="Liechtenstein">Liechtenstein</option>
                                <option value="Lithuania">Lithuania</option>
                                <option value="Luxembourg">Luxembourg</option>
                                <option value="Macedonia">Macedonia</option>
                                <option value="Madagascar">Madagascar</option>
                                <option value="Malawi">Malawi</option>
                                <option value="Malaysia">Malaysia</option>
                                <option value="Maldives">Maldives</option>
                                <option value="Mali">Mali</option>
                                <option value="Malta">Malta</option>
                                <option value="Marshall Islands">Marshall Islands</option>
                                <option value="Mauritania">Mauritania</option>
                                <option value="Mauritius">Mauritius</option>
                                <option value="Mexico">Mexico</option>
                                <option value="Micronesia, Federated States of">Micronesia, Federated States of</option>
                                <option value="Monaco">Monaco</option>
                                <option value="Mongolia">Mongolia</option>
                                <option value="Montenegro">Montenegro</option>
                                <option value="Morocco">Morocco</option>
                                <option value="Mozambique">Mozambique</option>
                                <option value="Myanmar (Burma)">Myanmar (Burma)</option>
                                <option value="Namibia">Namibia</option>
                                <option value="Nauru">Nauru</option>
                                <option value="Nepal">Nepal</option>
                                <option value="Netherlands">Netherlands</option>
                                <option value="New Zealand">New Zealand</option>
                                <option value="Nicaragua">Nicaragua</option>
                                <option value="Niger">Niger</option>
                                <option value="Nigeria">Nigeria</option>
                                <option value="Norway">Norway</option>
                                <option value="Oman">Oman</option>
                                <option value="Pakistan">Pakistan</option>
                                <option value="Palau">Palau</option>
                                <option value="Palestine">Palestine</option>
                                <option value="Panama">Panama</option>
                                <option value="Papua New Guinea">Papua New Guinea</option>
                                <option value="Paraguay">Paraguay</option>
                                <option value="Peru">Peru</option>
                                <option value="Philippines">Philippines</option>
                                <option value="Poland">Poland</option>
                                <option value="Portugal">Portugal</option>
                                <option value="Qatar">Qatar</option>
                                <option value="Republic of Moldova">Republic of Moldova</option>
                                <option value="Romania">Romania</option>
                                <option value="Russia">Russia</option>
                                <option value="Rwanda">Rwanda</option>
                                <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                                <option value="Saint Lucia">Saint Lucia</option>
                                <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
                                <option value="Samoa">Samoa</option>
                                <option value="San Marino">San Marino</option>
                                <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                                <option value="Saudi Arabia">Saudi Arabia</option>
                                <option value="Senegal">Senegal</option>
                                <option value="Serbia">Serbia</option>
                                <option value="Seychelles">Seychelles</option>
                                <option value="Sierra Leone">Sierra Leone</option>
                                <option value="Singapore">Singapore</option>
                                <option value="Slovakia">Slovakia</option>
                                <option value="Slovenia">Slovenia</option>
                                <option value="Solomon Islands">Solomon Islands</option>
                                <option value="Somalia">Somalia</option>
                                <option value="South Africa">South Africa</option>
                                <option value="South Sudan">South Sudan</option>
                                <option value="Spain">Spain</option>
                                <option value="Sri Lanka">Sri Lanka</option>
                                <option value="Sudan">Sudan</option>
                                <option value="Suriname">Suriname</option>
                                <option value="Swaziland">Swaziland</option>
                                <option value="Sweden">Sweden</option>
                                <option value="Switzerland">Switzerland</option>
                                <option value="Syrian Arab Republic">Syrian Arab Republic</option>
                                <option value="Taiwan">Taiwan</option>
                                <option value="Tajikistan">Tajikistan</option>
                                <option value="Thailand">Thailand</option>
                                <option value="Timor-Leste">Timor-Leste</option>
                                <option value="Togo">Togo</option>
                                <option value="Tonga">Tonga</option>
                                <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                                <option value="Tunisia">Tunisia</option>
                                <option value="Turkey">Turkey</option>
                                <option value="Turkmenistan">Turkmenistan</option>
                                <option value="Tuvalu">Tuvalu</option>
                                <option value="Uganda">Uganda</option>
                                <option value="Ukraine">Ukraine</option>
                                <option value="United Kingdom">United Kingdom</option>
                                <option value="United Republic of Tanzania">United Republic of Tanzania</option>
                                <option value="United States of America">United States of America</option>
                                <option value="Uruguay">Uruguay</option>
                                <option value="Uzbekistan">Uzbekistan</option>
                                <option value="Vanuatu">Vanuatu</option>
                                <option value="Vatican City (Holy See)">Vatican City (Holy See)</option>
                                <option value="Vietnam">Vietnam</option>
                                <option value="Yemen">Yemen</option>
                                <option value="Zambia">Zambia</option>
                                <option value="Zimbabwe">Zimbabwe</option>
                            </select>
                        </div>
                    </div>
                    {selectedCountry === "United Arab Emirates" &&
                        <div
                            className={
                                errors.EMIRATE ? 'error input-wrapper mb-2' : ' input-wrapper mb-2'
                            }
                        >
                            <label htmlFor="emirate">What is your emirate?</label>
                            <div>                        
                            <select
                                id="emirate"
                                name="emirate"
                                className="last"
                                {...register('emirate')}
                            >
                                <option defaultValue="" value="">
                                    What is your emirate?
                                </option>
                                <option value="Abu Dhabi">Abu Dhabi</option>
                                <option value="Dubai">Dubai</option>
                                <option value="Sharjah">Sharjah</option>
                                <option value="Ajman">Ajman</option>
                                <option value="Ras Al Khaimah">Ras Al Khaimah</option>
                                <option value="Umm Al Quwain">Umm Al Quwain</option>
                                <option value="Fujairah">Fujairah</option>
                            </select>
                            </div>
                        </div>
                    }
                    {props.termsText && (
                        <div dangerouslySetInnerHTML={{__html: props.termsText}}
                             className="py-md-3 [&>p>a]:text-white [&>a]:text-white [&>p>a]:underline"/>
                    )}
                    {props.status === "error" &&
                        <div className="text-red font-bold"
                             dangerouslySetInnerHTML={{__html: `<p>${formatMessage(props.message)}</p>`}}/>
                    }
                    <button type="submit" className="submit-button">
                        <span>SUBMIT</span>
                    </button>
                </>
            )}
        </form>
    )
}